import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';


@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {
  }

  canActivate() {
    if (!localStorage.getItem('refSinistre') || !localStorage.getItem('tokenConnexion')) {
      this.router.navigate(['/auth/signin']);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guard/auth.guard.ts